import React from 'react';

import { ChakraFlex, ChakraText, EquipUITheme } from '@equip.health/ui';

import { ChatDividerType } from '~/lib/constants/chat.constants';

const idPrefix = 'chat';
const idPostfix = 'divider';

const { caption } = EquipUITheme.typography;

interface ChatDividerProps {
  relativeDate: string;
  text: string;
  type: ChatDividerType;
}

const ChatDivider = React.forwardRef<HTMLDivElement, ChatDividerProps>(
  (
    { relativeDate, text }: ChatDividerProps,
    ref: React.ForwardedRef<HTMLDivElement>,
  ) => {
    return (
      <ChakraFlex
        alignItems="center"
        gridGap="16px"
        id={`${idPrefix}-chat-divider-wrapper__${relativeDate}__${idPostfix}`}
        justifyContent="center"
        margin="18px 0"
        padding="12px"
        ref={ref}
        width="100%"
      >
        <ChakraText
          {...caption}
          color="neutral.secondary"
          id={`${idPrefix}-chat-divider-text__${relativeDate}__${idPostfix}`}
          textTransform="capitalize"
          whiteSpace="nowrap"
        >
          {text}
        </ChakraText>
      </ChakraFlex>
    );
  },
);

ChatDivider.displayName = 'ChatDivider';
export default ChatDivider;
